import { render, staticRenderFns } from "./ItemStockSelector.vue?vue&type=template&id=5455c204&scoped=true"
import script from "./ItemStockSelector.vue?vue&type=script&lang=js"
export * from "./ItemStockSelector.vue?vue&type=script&lang=js"
import style0 from "./ItemStockSelector.vue?vue&type=style&index=0&id=5455c204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5455c204",
  null
  
)

export default component.exports